import { Routes, Route } from 'react-router-dom'
import { Navbar } from './components/layout/Navbar'
import { Footer } from './components/layout/Footer'
import { HomePage } from './pages/HomePage'
import { PlatformPage } from './pages/PlatformPage'
import { SolutionsPage } from './pages/SolutionsPage'
import { AboutPage } from './pages/AboutPage'

function App() {
    return (
        <div className="min-h-screen bg-slate-950">
            <Navbar />
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/platform" element={<PlatformPage />} />
                <Route path="/solutions" element={<SolutionsPage />} />
                <Route path="/about" element={<AboutPage />} />
            </Routes>
            <Footer />
        </div>
    )
}

export default App

